import { CloudAccountType } from '@repo/api-gw-sdk';
import type { Account } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';

export const useUpdateAccount = (
  onUpdated: () => void,
  setValidationInProgress: (validationInProgress: boolean) => void,
  setHasError: (hasError: boolean) => void,
  account: Account | undefined,
  expectVersionUpdate = true
) => {
  const dal = useDAL();

  const updateAccount = async () => {
    if (!account) {
      return;
    }

    try {
      setValidationInProgress(true);
      const previousInstalledVersion = account.installedVersion;

      let updateFunction;
      if (account.accountType === CloudAccountType.Source) {
        updateFunction = dal.cloudAccounts.source.update;
      } else if (account.accountType === CloudAccountType.Restore) {
        updateFunction = dal.cloudAccounts.restore.update;
      }

      const updatedAccount = await updateFunction?.(account.id, {
        overrideDefaultNetworkConfig:
          account.overrideDefaultNetworkConfig ?? false,
        cloudProvider: account.cloudProvider,
      });

      const newInstalledVersion = updatedAccount?.installedVersion;

      if (
        expectVersionUpdate &&
        previousInstalledVersion === newInstalledVersion
      ) {
        setHasError(true);
      } else {
        onUpdated();
      }
    } catch {
      setHasError(true);
    } finally {
      setValidationInProgress(false);
    }
  };

  return {
    updateAccount,
  };
};
